const LocalStorageType = {
    USER_DETAILS: "userDetails",
    MENU_STATE: "menuState",

    // Tutoriais já assistidos na Central de Ajuda. Fica no navegador de propósito: é
    // conveniência de quem está aprendendo, não informação que o sistema precise guardar.
    HELP_WATCHED_TUTORIALS: "helpWatchedTutorials"
}

export default LocalStorageType;